import { App, OpenWebUrlTarget } from '@servicetitan/web-feature-app-service';

/**
 * Opens a web URL using the appropriate target based on setup data configuration
 * Falls back to window.open if App.openWebUrl fails
 *
 * @param url - The URL to open
 * @param useInAppBrowser - Whether to use in-app browser or external browser
 */
export const openWebUrl = (url: string, useInAppBrowser?: boolean): Promise<void> => {
    const target = useInAppBrowser ? OpenWebUrlTarget.InApp : OpenWebUrlTarget.Browser;

    return App.openWebUrl({
        url,
        target,
    }).catch(() => {
        // Fallback to original behavior
        const windowResult = window.open(url, '_blank');
        if (windowResult === null) {
            window.location.href = url;
        }
    });
};
